export default __webpack_public_path__ + "./image/5fa626dbe7d1566616ed355acea5104f.png";